/**
 * ExportButtons Component
 * Export controls for WAV, MP3, and Track Pack
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Download, FileAudio, Layers, Loader2 } from 'lucide-react';

export const ExportButtons = ({
  isExporting,
  onExportWav,
  onExportMp3,
  onOpenBatchExporter,
  canExportMp3 = true,
  showLabels = true,
}) => {
  return (
    <div className="flex items-center">
      {/* WAV Export - Prominent */}
      <Button
        variant="outline"
        size="sm"
        onClick={onExportWav}
        disabled={isExporting}
        className="border-green-500/40 bg-green-500/10 text-green-400 hover:bg-green-500/20 hover:text-white px-3"
        data-testid="export-wav"
        title="Export as WAV"
      >
        {isExporting ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <Download className="w-4 h-4" />
        )}
        <span className="ml-1.5 text-xs font-medium">{isExporting ? 'Exporting...' : 'WAV'}</span>
      </Button>
      
      {/* MP3 Export - Prominent */}
      <Button
        variant="outline"
        size="sm"
        onClick={onExportMp3}
        disabled={isExporting}
        className={`border-amber-500/40 bg-amber-500/10 text-amber-400 hover:bg-amber-500/20 hover:text-white px-3 ml-1 relative ${!canExportMp3 ? 'opacity-75' : ''}`}
        data-testid="export-mp3"
        title={canExportMp3 ? 'Export as MP3' : 'MP3 export requires Pro subscription'}
      >
        {isExporting ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <FileAudio className="w-4 h-4" />
        )}
        <span className="ml-1.5 text-xs font-medium">{isExporting ? 'Exporting...' : 'MP3'}</span>
        {!canExportMp3 && (
          <span className="absolute -top-1 -right-1 text-[8px] bg-amber-500 text-black px-1 rounded-full">
            PRO
          </span>
        )}
      </Button>
      
      {/* Track Pack (Batch Export) */}
      <Button
        variant="outline"
        size="sm"
        onClick={onOpenBatchExporter}
        className="border-violet-500/50 text-violet-400 hover:bg-violet-500/20 px-2 md:px-3 ml-1"
        data-testid="track-pack-btn"
        title="Export/Import multiple tracks"
      >
        <Layers className="w-4 h-4" />
        {showLabels && <span className="ml-2 hidden md:inline">Track Pack</span>}
      </Button>
    </div>
  );
};

export default ExportButtons;
